/**
 * Touch-cart store (zustand) — CRM redesign step 5.
 *
 * Holds ONLY the fill parameters for the right-hand "Касание-корзина" panel:
 * which touch the selection goes into and the result mark. The selected entities
 * themselves live in store/selection.ts (mode ids|filter) — NOT duplicated here.
 */

import { create } from "zustand";

export type TouchResult = "Да" | "Нет";

export interface TouchCartState {
  /** Target touch id for "fill", or null until one is picked. */
  touchId: number | null;
  /** Display name of the picked touch (for the chip/label), or null. */
  touchName: string | null;
  /** Result mark written for every filled entity. */
  result: TouchResult;
  /** Pick a touch (id + name) in one shot; pass null to clear. */
  setTouch: (id: number | null, name?: string | null) => void;
  setResult: (r: TouchResult) => void;
  reset: () => void;
}

export const useTouchCart = create<TouchCartState>((set) => ({
  touchId: null,
  touchName: null,
  result: "Да",
  setTouch: (id, name = null) => set(() => ({ touchId: id, touchName: id == null ? null : name })),
  setResult: (r) => set(() => ({ result: r })),
  reset: () => set(() => ({ touchId: null, touchName: null, result: "Да" })),
}));
